import { useCallback, useState } from 'react';
import type { CardPerson } from './cardPeople';

/** People ticked for printing, kept across pages of a list. */
export const useCardSelection = () => {
  const [selected, setSelected] = useState<Map<string, CardPerson>>(new Map());

  const toggle = useCallback((person: CardPerson) => setSelected(prev => {
    const next = new Map(prev);
    if (next.has(person.key)) next.delete(person.key); else next.set(person.key, person);
    return next;
  }), []);

  /** Tick every row on the page, or untick them all when they already are. */
  const togglePage = useCallback((page: CardPerson[]) => setSelected(prev => {
    const next = new Map(prev);
    const all = page.length > 0 && page.every(p => next.has(p.key));
    page.forEach(p => (all ? next.delete(p.key) : next.set(p.key, p)));
    return next;
  }), []);

  const clear = useCallback(() => setSelected(new Map()), []);

  return { selected, toggle, togglePage, clear };
};
